export default class AssignmentHelper {
    static sort(assignments) {
        return assignments.sort((a, b) => {
            if (a.isSampleEdit) {
                return -100;
            }

            if (a.isSummary) {
                return 100;
            }
            return a.editingServicePart > b.editingServicePart ? 1 : -1;
        });
    }

    static nest(assignments) {
        assignments.forEach((assignment) => {
            if (!assignment.previousAssignment) {
                return;
            }
            let index = assignments.findIndex(a => a.id === assignment.previousAssignment.id);
            if (index === -1) {
                return;
            }
            if (assignments[index].nextAssignments === undefined) {
                assignments[index].nextAssignments = [];
            }
            assignments[index].nextAssignments.push(assignment);
        });

        return assignments;
    }

    static createGroupName(group) {
        return group.map(a => a.name).join(', ');
    }
}
